import * as actionTypes from "./actionTypes/drawerActionTypes";

export const openOnboardingWizard = () => ({
  type: actionTypes.OPEN_ONBOARDING_WIZARD,
});

export const closeDrawer = () => ({
  type: actionTypes.CLOSE_DRAWER,
});
